import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { JsonLDArticle, JsonLDListItem } from '@cinch/oxd-components/json-ld/src'

import SEO from './seo.component'

export type Breadcrumb = Omit<JsonLDListItem['schema'], 'position'>

export interface SEOContainerProps {
  title?: string
  desc?: string
  noIndex?: boolean
  articleSchema?: JsonLDArticle['schema']
  breadcrumbs?: Breadcrumb[]
}

const SEOContainer: React.FC<SEOContainerProps> = (props) => {
  const {
    site: { siteMetadata },
  }: { site: { siteMetadata: Cinch.SiteMetadata } } = useStaticQuery(graphql`
    query SiteMetadataQuery {
      site {
        siteMetadata {
          contactPoint {
            contactType
            email
          }
          defaultTitle
          defaultDescription
          legalName
          postalAddress {
            streetAddress
            addressLocality
            addressRegion
            postalCode
            addressCountry
          }
          siteLanguage
          siteUrl
          socialLinks {
            href
          }
          staticLogo
        }
      }
    }
  `)

  return <SEO {...props} siteMetadata={siteMetadata} />
}

export default SEOContainer
